// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge__LLiet","asSeenOnTV":"asSeenOnTV__luNhY"};